<div class="home-page">

  <!-- ── Saudação ─────────────────────────────────────────────────────────── -->
  <div class="greeting-block" data-tour="home-greeting">
    <div class="greeting-main">
      <h1 class="greeting-title">
        {{ saudacao }},&nbsp;<span class="greeting-name">{{ nomeUsuario }}</span>
      </h1>
      <p class="greeting-date">{{ dataAtual }}</p>
    </div>
    <div class="help-buttons">
      <button
        pButton
        type="button"
        icon="pi pi-book"
        class="p-button-text p-button-rounded p-button-sm tour-help-btn"
        pTooltip="Ajuda desta tela"
        tooltipPosition="left"
        [tooltipStyleClass]="'menu-tooltip'"
        (click)="abrirManual()">
      </button>
      <button
        pButton
        type="button"
        icon="pi pi-compass"
        class="p-button-text p-button-rounded p-button-sm tour-help-btn"
        pTooltip="Tour da tela"
        tooltipPosition="left"
        [tooltipStyleClass]="'menu-tooltip'"
        (click)="iniciarTourManual()">
      </button>
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════════════════════ -->
  <!-- VISÃO GESTOR                                                         -->
  <!-- ══════════════════════════════════════════════════════════════════════ -->
  <ng-container *ngIf="isGestor">

    <!-- ── Setup checklist ──────────────────────────────────────────────── -->
    <app-setup-checklist
      *ngIf="mostrarSetup"
      [status]="setupStatus"
      (dispensar)="onDispensarSetup()">
    </app-setup-checklist>

    <!-- ── Stat cards ───────────────────────────────────────────────────── -->
    <div class="stats-grid" data-tour="home-stats">

      <!-- Total -->
      <div class="stat-card">
        <div class="stat-card__icon stat-card__icon--blue">
          <i class="pi pi-users"></i>
        </div>
        <div class="stat-card__body">
          <ng-container *ngIf="!carregando; else skeletonNum">
            <span class="stat-card__number">{{ resumo?.totalColaboradores ?? 0 }}</span>
          </ng-container>
          <span class="stat-card__label">Total de colaboradores</span>
        </div>
      </div>

      <!-- Ativo -->
      <div class="stat-card stat-card--clickable"
        (click)="navegarParaStatus('ATIVO')">
        <div class="stat-card__icon stat-card__icon--green">
          <i class="pi pi-wifi"></i>
          <span class="stat-card__badge"></span>
        </div>
        <div class="stat-card__body">
          <ng-container *ngIf="!carregando; else skeletonNum">
            <span class="stat-card__number stat-card__number--green">{{ resumo?.totalOnline ?? 0 }}</span>
          </ng-container>
          <span class="stat-card__label">Ativo agora</span>
        </div>
      </div>

      <!-- Pausa -->
      <div class="stat-card stat-card--clickable"
        (click)="navegarParaStatus('PAUSA')">
        <div class="stat-card__icon stat-card__icon--amber">
          <i class="pi pi-clock"></i>
        </div>
        <div class="stat-card__body">
          <ng-container *ngIf="!carregando; else skeletonNum">
            <span class="stat-card__number stat-card__number--amber">{{ resumo?.totalAusente ?? 0 }}</span>
          </ng-container>
          <span class="stat-card__label">Pausa</span>
        </div>
      </div>

      <!-- Ausente -->
      <div class="stat-card stat-card--clickable"
        (click)="navegarParaStatus('AUSENTE')">
        <div class="stat-card__icon stat-card__icon--slate">
          <i class="pi pi-moon"></i>
        </div>
        <div class="stat-card__body">
          <ng-container *ngIf="!carregando; else skeletonNum">
            <span class="stat-card__number stat-card__number--slate">{{ resumo?.totalOffline ?? 0 }}</span>
          </ng-container>
          <span class="stat-card__label">Ausente</span>
        </div>
      </div>

    </div>

    <!-- ── Presença ─────────────────────────────────────────────────────── -->
    <div class="presence-section" *ngIf="!carregando && resumo">
      <div class="presence-header">
        <span class="presence-label">
          <i class="pi pi-chart-bar"></i>
          Presença em tempo real
        </span>
        <span class="presence-percent">{{ onlinePercent }}%</span>
      </div>
      <div class="presence-track">
        <div class="presence-fill" [style.width.%]="onlinePercent"></div>
      </div>
      <p class="presence-caption">
        {{ resumo.totalOnline }} de {{ resumo.totalColaboradores }} colaboradores conectados
      </p>
    </div>

    <!-- ── Atalhos gestor ───────────────────────────────────────────────── -->
    <p class="section-label">Atalhos</p>
    <div class="quick-actions" data-tour="home-quick-actions">
      <div class="action-card" routerLink="/pessoas">
        <div class="action-card__icon action-card__icon--blue">
          <i class="pi pi-users"></i>
        </div>
        <div class="action-card__body">
          <strong>Pessoas</strong>
          <span>Visualize times, status e indicadores da equipe</span>
        </div>
        <i class="pi pi-chevron-right action-card__arrow"></i>
      </div>

      <div class="action-card" routerLink="/relatorios">
        <div class="action-card__icon action-card__icon--purple">
          <i class="pi pi-chart-bar"></i>
        </div>
        <div class="action-card__body">
          <strong>Relatórios</strong>
          <span>Relatórios semanais com score e indicadores por IA</span>
        </div>
        <i class="pi pi-chevron-right action-card__arrow"></i>
      </div>

      <div class="action-card" routerLink="/empresa">
        <div class="action-card__icon action-card__icon--indigo">
          <i class="pi pi-building"></i>
        </div>
        <div class="action-card__body">
          <strong>Empresa</strong>
          <span>Gerencie departamentos, times, cargos e hierarquia</span>
        </div>
        <i class="pi pi-chevron-right action-card__arrow"></i>
      </div>
    </div>

    <!-- ── Tour replay ──────────────────────────────────────────────────── -->
    <div class="home-footer">
      <button class="tour-replay-btn" type="button" (click)="iniciarTour()">
        <i class="pi pi-compass"></i>
        Fazer tour novamente
      </button>
    </div>

  </ng-container>

  <!-- ══════════════════════════════════════════════════════════════════════ -->
  <!-- VISÃO COLABORADOR                                                    -->
  <!-- ══════════════════════════════════════════════════════════════════════ -->
  <ng-container *ngIf="!isGestor">

    <p class="section-label">Atalhos</p>
    <div class="quick-actions quick-actions--two-col">
      <div class="action-card" routerLink="/meu-painel">
        <div class="action-card__icon action-card__icon--blue">
          <i class="pi pi-th-large"></i>
        </div>
        <div class="action-card__body">
          <strong>Meu Painel</strong>
          <span>Acompanhe suas atividades e indicadores</span>
        </div>
        <i class="pi pi-chevron-right action-card__arrow"></i>
      </div>

      <div class="action-card" routerLink="/meus-relatorios">
        <div class="action-card__icon action-card__icon--purple">
          <i class="pi pi-chart-bar"></i>
        </div>
        <div class="action-card__body">
          <strong>Meus Relatórios</strong>
          <span>Seus relatórios semanais de desempenho</span>
        </div>
        <i class="pi pi-chevron-right action-card__arrow"></i>
      </div>
    </div>

  </ng-container>

</div>

<ng-template #skeletonNum>
  <p-skeleton width="4rem" height="2.5rem" borderRadius="8px"></p-skeleton>
</ng-template>